import _ from 'underscore';
import $ from 'jquery';
import Numeral from 'numeral';
import Router from 'root/router';
import UI from 'root/ui';
import Cache from 'root/cache';
import Modal from 'root/module/modal';
import Modals from 'root/modals';
import View from 'view/base';
import View_Notification from 'view/inbox/notification';
import View_Feedback_Inbox from 'view/feedback_inbox/index';
import View_Response_Inbox from 'view/inbox/survey_response';
import View_System_Inbox from 'view/inbox/system';
import { getProjects as getInboxProjects } from 'service/inbox';

export default View.extend({
    tagName: 'section',
    className: 'fullscroll', // with fullscroll-action-bar

    polling_interval: 10000,

    page: 1,
    limit: 500, // show the latest 500 without pagination

    count: 0, // total notifications

    selected_notifications: {},

    open_notification: null,

    filters: {
        show_read: true,
        show_snoozed: false,
        sort_order: 'DESC'
    },

    projects: {},

    search_text: '',

    portal_loaded: {},

    user_data: {},

    views: {
        notification: {},
        feedback_inbox: {},
        survey_inbox: {},
        system_inbox: {},
    },

    events: {
        'click .filter-show-read'        : 'onFilterChange',
        'click .filter-show-snoozed'     : 'onFilterChange',
        'click .filter-project'          : 'onOpenProjectFilter',
        'click .sort-order'              : 'onSortOrderChange',
        'click #notification_select_all' : 'onSelectAll',
        'click .clear-selection'         : 'onUnSelectAll',
        'click .bulk-read'               : 'onBulkRead',
        'click .bulk-unread'             : 'onBulkUnread',
        'click .bulk-delete'             : 'onBulkDelete',
        'click .delete-all'              : 'onDeleteAll',
        'click .delete-all-read'         : 'onDeleteAllRead',
        'submit .quick-search'           : 'onQuickSearch',
        'click .quick-search-clear'      : 'onQuickSearchClear'
    },

    dom_handlers: {
        onFilterChange: function(e) {
            $(e.currentTarget).toggleClass('selected');

            // update filters
            this.filters = this.getFiltersFromUI();

            try {
                var user_settings = JSON.parse(Cache.app.getUserSetting('inbox_filter', false));
                user_settings = {...user_settings, ...this.filters};

                // save filter
                Cache.app.addUserSetting('inbox_filter', JSON.stringify(user_settings), false);
            } catch (e) {
                // ignore JSON parse error
            }

            // search again
            this.page = 1;
            this.search();
        },

        onOpenProjectFilter: function(e) {
            Modals.editInboxNotification();
        },

        onSortOrderChange: function(e) {
            // update UI
            this.$el.find('.sort-order').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            // update filters
            this.filters = this.getFiltersFromUI();

            // save filter
            Cache.app.addUserSetting('inbox_filter', JSON.stringify(this.filters), false);

            // search again
            this.page = 1;
            this.search();
        },

        onSelectAll: function(e) {
            var selected = $(e.currentTarget).prop('checked');

            _.each(this.views.notification, (view) => {
                view.select(selected);
            });
        },

        onUnSelectAll: function(e) {
            e.preventDefault();

            _.each(this.views.notification, (view) => {
                view.select(false);
            });
        },

        onBulkRead: function() {
            var notifications = [];
            _.each(this.selected_notifications, (model) => {
                model.set('is_read', true);

                notifications.push({
                    id: model.get('id'),
                    is_read: true
                });
            });

            Cache.app.request({
                action: 'inbox/update',
                data: {
                    notifications: notifications
                }
            });

            UI.success('Notifications marked as read');
        },

        onBulkUnread: function() {
            var notifications = [];
            _.each(this.selected_notifications, (model) => {
                model.set('is_read', false);

                notifications.push({
                    id: model.get('id'),
                    is_read: false
                });
            });

            Cache.app.request({
                action: 'inbox/update',
                data: {
                    notifications: notifications
                }
            });

            UI.success('Notifications marked as unread');
        },

        onBulkDelete: function() {
            Modal.confirm('Are you sure you want to delete the selected notifications?', () => {
                var ids = [];
                _.each(this.selected_notifications, (model) => {
                    ids.push(model.get('id'));
                });

                Cache.app.request({
                    action: 'inbox/delete',
                    data: {
                        ids: ids
                    },
                    success: () => {
                        _.each(this.selected_notifications, (model) => {
                            Cache.inbox_notification.remove(model);
                        });
                        UI.success('Notifications deleted');
                    }
                });
            }, this, 'Yes, delete', 'Delete Notifications', 'secondary');
        },

        onDeleteAll: function() {
            Modal.confirm('This will delete all notifications in your inbox.', () => {
                Cache.app.request({
                    action: 'inbox/delete',
                    data: {
                        ids: ['all']
                    },
                    success: () => {
                        Cache.inbox_notification.remove(Cache.inbox_notification.models);
                        UI.success('All notifications deleted');
                    }
                });
            }, this, 'Delete all', 'Delete all notifications', 'secondary');
        },

        onDeleteAllRead: function() {
            Modal.confirm('This will delete all read notifications in your inbox.', () => {
                Cache.app.request({
                    action: 'inbox/delete',
                    data: {
                        ids: ['all_read']
                    },
                    success: () => {
                        Cache.inbox_notification.remove(Cache.inbox_notification.models);
                        UI.success('All notifications deleted');
                    }
                });
            }, this, 'Delete all', 'Delete all ready notifications', 'secondary');
        },

        onQuickSearch: function(e) {
            this.search_text = this.$el.find('.quick-search input').val().trim();
            this.$el.find('.quick-search-clear').toggle(this.search_text.length > 0);

            this.page = 1;
            this.search();
        },

        onQuickSearchClear: function(e) {
            this.search_text = '';
            this.$el.find('.quick-search input').val('');
            this.$el.find('.quick-search-clear').hide();

            this.page = 1;
            this.search();
        }
    },

    event_handlers: {
        onNotificationOpen: function(model) {
            if (Cache.account.get('is_expired')) {
                Modals.expiredAccount();
                return;
            }

            if (this.open_notification?.id === model.id) {
                return;
            }

            // TODO: check feedback 7-day expiry

            // highlight in the UI
            this.$el.find('.inbox-notification').removeClass('selected');
            this.views.notification[model.id].$el.addClass('selected');

            this.open_notification = model;

            // remove existing views
            if (this.views.feedback_inbox instanceof View_Feedback_Inbox) {
                this.views.feedback_inbox.remove();
            }

            if (this.views.response_inbox instanceof View_Response_Inbox) {
                this.views.response_inbox.remove();
            }

            if (this.views.system_inbox instanceof View_System_Inbox) {
                this.views.system_inbox.remove();
            }

            switch (model.get('object_type')) {
                case 'feedback':
                    // expired account can't manage feedback
                    if (Cache.account.get('is_expired')) {
                        Modals.expiredAccount();
                        return;
                    }

                    var feedback_id = model.get('object_id');
                    var feedback_model = Cache.feedback.get(feedback_id);

                    // always load the feedback model to show its latest data
                    Cache.app.request({
                        action: 'feedback/search',
                        data: {
                            ids: [feedback_id],
                            all_projects: true
                        },
                        success: (response) => {
                            if (!response.feedback.length) {
                                UI.error('Feedback not found');
                                return;
                            }

                            // add or update comments
                            response.feedback_comment.forEach((data) => {
                                if (Cache.feedback_comment.get(data.id)) {
                                    Cache.feedback_comment.get(data.id).set(data);
                                } else {
                                    Cache.feedback_comment.add(data);
                                }
                            });

                            // add screenshots (screenshots can't be post edited, so update is not needed)
                            Cache.feedback_screenshot.add(response.feedback_screenshot);

                            // add or update feedback
                            if (feedback_model) {
                                feedback_model.set(response.feedback[0]);
                            } else {
                                Cache.feedback.add(response.feedback);
                            }

                            this.openFeedback(feedback_id);
                        }
                    });

                    break;
                case 'survey_response':
                    var survey_response_id = model.get('object_id');
                    this.openSurveyResponse(survey_response_id);

                    break;
                case 'system':
                    this.openSystemNotification(model);
                    break;
            }

            // after 3 seconds, if the notification is still open, mark as read
            setTimeout(() => {
                if (this.open_notification && this.open_notification.id === model.id && !model.get('is_read')) {
                    model.set('is_read', true);

                    Cache.app.request({
                        action: 'inbox/update',
                        data: {
                            notifications: [
                                {
                                    id: model.get('id'),
                                    is_read: true
                                }
                            ]
                        }
                    });
                }
            }, 3000);
        },

        onNotificationSelect: function(model, selected) {
            if (selected) {
                this.selected_notifications[model.get('id')] = model;
            } else {
                delete this.selected_notifications[model.get('id')];
            }

            this.toggleBulkActions();
        },

        onNotificationReset: function() {
            // remove old views
            _.each(this.views.notification, (view) => {
                view.remove();
            });

            this.views.notification = {};
            this.selected_notifications = {};

            // create new views
            Cache.inbox_notification.each((model) => {
                this.createNotificationView(model);
            });

            this.updateCounter();
            this.toggleBulkActions();
        },

        onNotificationAdd: function(model) {
            this.count++;

            this.createNotificationView(model);

            this.updateCounter();
            this.toggleBulkActions();
        },

        onNotificationRemove: function(model, collection, options) {
            this.views.notification[model.id].remove();
            delete this.views.notification[model.id];
            delete this.selected_notifications[model.get('id')];

            this.count--;

            // reset open notification
            if (this.open_notification && this.open_notification.id === model.id && model.get('ignore_delete') !== true) {
                var next_model = Cache.inbox_notification.at(options.index);

                // auto select first one
                if (next_model) {
                    this.event_handlers.onNotificationOpen.call(this, next_model);
                } else {
                    this.open_notification = null;
                    this.emptyInboxView();
                }
            }

            this.updateCounter();
            this.toggleBulkActions();
        },

        onNotificationSnooze: function(model) {
            if (!this.filters.show_snoozed && model.get('snooze_time')) {
                Cache.inbox_notification.remove(model);
            }
        },

        onFeedbackDelete: function(model) {
            var model = Cache.inbox_notification.findWhere({
                object_type: 'feedback',
                object_id: model.get('id')
            });

            if (model) {
                Cache.inbox_notification.remove(model);
            }
        },

        onFeedbackMerge: function(model) {
            var merged_feedback_ids = model.get('merged_feedback_ids') || [];

            if (!merged_feedback_ids.length) {
                return;
            }

            merged_feedback_ids.forEach((id) => {
                var model = Cache.inbox_notification.findWhere({
                    object_type: 'feedback',
                    object_id: id,
                });

                if (model) {
                    Cache.inbox_notification.remove(model);
                }
            })
        },

        onSurveyResponseDelete: function(model) {
            var model = Cache.inbox_notification.findWhere({
                object_type: 'survey_response',
                object_id: model.get('id')
            });

            if (notification) {
                Cache.inbox_notification.remove(model);
            }
        },

        onUserSettingChange: function(model, b, c) {
            if (model.get('user_id') !== Cache.real_user_id) {
                return;
            }

            var projects = getInboxProjects();

            if (!_.isEqual(this.projects, projects)) {
                this.projects = {...projects};

                // search again
                this.page = 1;
                this.search();
            }
        }
    },

    createNotificationView: function(model) {
        var model_position = Cache.inbox_notification.indexOf(model);

        this.views.notification[model.id] = new View_Notification({model: model});

        if (model_position === 0) {
            this.views.notification[model.id].render().$el.prependTo(this.$el.find('.scroll-list'));
        } else {
            var previous_view = this.$el.find('.scroll-list .inbox-notification').eq(model_position - 1);
            this.views.notification[model.id].render().$el.insertAfter(previous_view);
        }

        // restore selected state
        if (this.open_notification && this.open_notification.id === model.id) {
            this.views.notification[model.id].$el.addClass('selected');
        }

        this.views.notification[model.id].on('open',   this.event_handlers.onNotificationOpen.bind(this));
        this.views.notification[model.id].on('select', this.event_handlers.onNotificationSelect.bind(this));
    },

    emptyInboxView: function() {
        if (this.views.feedback_inbox instanceof View_Feedback_Inbox) {
            this.views.feedback_inbox.remove();
            this.views.feedback_inbox = {};
        }

        if (this.views.response_inbox instanceof View_Response_Inbox) {
            this.views.response_inbox.remove();
            this.views.response_inbox = {};
        }
    },

    openNotificationFromURL: function() {
        var notification_id = Router.getQueryString('notification_id');

        if (!notification_id) {
            return;
        }

        const model = Cache.inbox_notification.get(notification_id);

        if (!model) {
            return;
        }

        this.event_handlers.onNotificationOpen.call(this, model);
        setTimeout(() => {
            this.scrollToNotification(this.views.notification[model.id].$el);
        }, 0)
    },

    scrollToNotification: function(notification_el) {
        notification_el.get(0).scrollIntoView();
    },

    initialize: function() {
        // load saved filters
        var saved_filters = Cache.app.getUserSetting('inbox_filter', false);

        try {
            saved_filters = JSON.parse(saved_filters);

            // validate data (do not always trust the JSON)
            this.filters = {
                show_snoozed  : typeof saved_filters.show_snoozed === 'boolean' ? saved_filters.show_snoozed : this.filters.show_snoozed,
                show_read     : typeof saved_filters.show_read    === 'boolean' ? saved_filters.show_read    : this.filters.show_read,
                sort_order    : saved_filters.sort_order === 'ASC' ? 'ASC' : 'DESC'
            };
        } catch (e) {
        }

        this.projects = getInboxProjects();

        // event listeners
        this.listenTo(Cache.inbox_notification, 'reset',                      this.event_handlers.onNotificationReset);    // search reset
        this.listenTo(Cache.inbox_notification, 'remove',                     this.event_handlers.onNotificationRemove);   // delete
        this.listenTo(Cache.inbox_notification, 'add',                        this.event_handlers.onNotificationAdd);      // new notification
        this.listenTo(Cache.inbox_notification, 'change:snooze_time',         this.event_handlers.onNotificationSnooze);   // snooze or unsnooze notification
        this.listenTo(Cache.feedback,           'remove',                     this.event_handlers.onFeedbackDelete);       // feedback deleted
        this.listenTo(Cache.feedback,           'change:merged_feedback_ids', this.event_handlers.onFeedbackMerge);
        this.listenTo(Cache.survey_response,    'remove',                     this.event_handlers.onSurveyResponseDelete); // survey response deleted
        this.listenTo(Cache.user_setting,       'add remove',                 this.event_handlers.onUserSettingChange);    // when project filter is changed

        this.on('remove', () => {
            Cache.remove('integration_loaded');
            clearInterval(this.live_reload_interval);
        });

        Cache.inbox_notification.comparator = (a, b) => {
            if (this.filters.sort_order === 'DESC') {
                return a.get('notification_time') < b.get('notification_time') ? 1 : -1;
            } else {
                return a.get('notification_time') > b.get('notification_time') ? 1 : -1;
            }
        };
    },

    onPageReady: function() {
        // reset cached feedback data, otherwise when User B changes feedback status, User A's inbox will show the cached feedback status
        Cache.feedback.reset();

        this.search();
        this.liveReload();
    },

    liveReload: function() {
        this.live_reload_interval = setInterval(() => {
            this.search(false, true);
        }, this.polling_interval);
    },

    search: function(show_loading = true, live_reload = false) {
        // do not clear the selection when doing polling
        if (this.open_notification && !live_reload) {
            this.open_notification = null;
            this.emptyInboxView();
        }

        if (show_loading) {
            this.$el.find('.region-notification-list').addClass('loading');
            this.$el.find('.notification-count').text('loading...');
        }

        var latest_notification;

        if (Cache.inbox_notification.length) {
            latest_notification = this.filters.sort_order === 'DESC' ? Cache.inbox_notification.at(0) : Cache.inbox_notification.at(Cache.inbox_notification.length - 1);
        }

        // abort previous search
        if (this.search_xhr) {
            this.search_xhr.abort();
        }

        var projects_search = {...this.projects};
        Cache.app.getProjectsByUser(Cache.real_user_id).forEach((project) => {
            if (projects_search[project.id] === undefined) {
                projects_search[project.id] = 'on';
            }
        });

        this.search_xhr = Cache.app.request({
            action: 'inbox/search',
            data: {
                page: this.page,
                limit: this.limit,
                search: this.search_text,
                show_read: this.filters.show_read,
                show_snoozed: this.filters.show_snoozed,
                sort_order: this.filters.sort_order,
                from: live_reload && latest_notification ? latest_notification.get('notification_time') + 1 : undefined,
                projects: projects_search
            },
            success: (response) => {
                if (live_reload) {
                    response.notifications.forEach((data) => {
                        var notification_model = Cache.inbox_notification.get(data.id);

                        if (notification_model) {
                            // remove and re-add to update its position in the list
                            notification_model.set({
                                'ignore_delete': true
                            });
                            Cache.inbox_notification.remove(notification_model);
                        }

                        Cache.inbox_notification.add(data);
                    });
                } else {
                    this.count = response.count;
                    Cache.inbox_notification.reset(response.notifications);
                    this.openNotificationFromURL();
                }
            },
            complete: () => {
                this.$el.find('.region-notification-list').removeClass('loading');
            }
        });
    },

    getFiltersFromUI: function() {
        return {
            show_read      : this.$el.find('.filter-show-read').hasClass('selected'),
            show_snoozed   : this.$el.find('.filter-show-snoozed').hasClass('selected'),
            sort_order     : this.$el.find('.sort-order.selected').data('val')
        };
    },

    toggleLoading: function(show) {
        this.$el.find('.region-notification-body').toggleClass('loader', show);
    },

    openFeedback: function(feedback_id) {
        var feedback_model = Cache.feedback.get(feedback_id);
        var project_id = feedback_model.get('project_id');
        var integration_loaded = Cache.get('integration_loaded') ? Cache.get('integration_loaded') : [];

        if (feedback_model.isExpired()) {
            Modals.expiredFeedback();
            return;
        }

        // Only the current project always has workflow, category, portal & integrations loaded in the Cache
        // load them if not found
        if (!Cache.workflow.findWhere({project_id: project_id})) {
            Cache.app.request({
                action: 'workflow/get',
                data: {
                    project_id: project_id
                },
                success: (response) => {
                    Cache.workflow.add(response);
                    this.openFeedback(feedback_id);
                }
            });

            this.toggleLoading(true);
            return;
        }

        if (!Cache.feedback_autoreply.findWhere({project_id: project_id})) {
            Cache.app.request({
                action: 'feedback\\autoreply/search',
                data: {
                    project_id: project_id
                },
                success: (response) => {
                    Cache.feedback_autoreply.add(response);
                    this.openFeedback(feedback_id);
                }
            });

            this.toggleLoading(true);
            return;
        }

        if (!Cache.feedback_category.findWhere({project_id: project_id})) {
            Cache.app.request({
                action: 'feedback\\category/load',
                data: {
                    project_id: project_id
                },
                success: (response) => {
                    Cache.feedback_category.add(response);
                    this.openFeedback(feedback_id);
                }
            });

            this.toggleLoading(true);
            return;
        }

        if (!Cache.portal.findWhere({project_id: project_id}) && !this.portal_loaded[project_id]) {
            Cache.app.request({
                action: 'portal/get',
                data: {
                    project_id: project_id
                },
                success: (response) => {
                    this.portal_loaded[project_id] = true;
                    Cache.portal.add(response);
                    this.openFeedback(feedback_id);
                }
            });

            this.toggleLoading(true);
            return;
        }

        if (project_id !== Cache.default_project_id && integration_loaded.indexOf(project_id) === -1) {
            Cache.app.request({
                action: 'integration/getData',
                data: {
                    project_id: project_id
                },
                success: (response) => {
                    integration_loaded.push(project_id);
                    Cache.add('integration_loaded', integration_loaded, false);

                    _.each(response, (data, key) => {
                        if (typeof Cache['integration_' + key] !== 'undefined') {
                            Cache['integration_' + key].add(data);
                        }
                    });

                    this.openFeedback(feedback_id);
                }
            });

            this.toggleLoading(true);
            return;
        }

        this.toggleLoading(false);

        this.views.feedback_inbox = new View_Feedback_Inbox({
            model: feedback_model,
            initial_search_feedbacks: [],
        });
        this.views.feedback_inbox.render().$el.appendTo(this.$el.find('.region-notification-body'));
    },

    openSurveyResponse: function(survey_response_id) {
        if (!Cache.survey_response.get(survey_response_id)) {
            Cache.app.request({
                action: 'survey_response/search',
                data: {
                    response_ids: [survey_response_id]
                },
                success: (response) => {
                    if (response.user_data) {
                        this.user_data = response.user_data;
                    }

                    if (response.data.length) {
                        Cache.survey_response.add(response.data);
                        this.openSurveyResponse(survey_response_id);
                    } else {
                        UI.error('Survey response not found');
                    }
                }
            });

            return;
        }

        var response_model = Cache.survey_response.get(survey_response_id);

        if (response_model.isExpired()) {
            Modals.expiredSurvey();
            return;
        }

        this.views.response_inbox = new View_Response_Inbox({
            model: response_model,
            user_data: this.user_data
        });
        this.views.response_inbox.render().$el.appendTo(this.$el.find('.region-notification-body'));
    },

    openSystemNotification: function(notification_model) {
        this.views.system_inbox = new View_System_Inbox({
            model: notification_model
        });
        this.views.system_inbox.render().$el.appendTo(this.$el.find('.region-notification-body'));
    },

    toggleBulkActions: function() {
        var total_selected = _.size(this.selected_notifications);

        this.$el.find('.fullscroll-action-bar > div').toggleClass('flip', total_selected > 0);
        this.$el.find('.item-counter > span').text(total_selected + ' notification' + (total_selected === 1 ? '' : 's') + ' selected');
        this.$el.find('#notification_select_all').prop('checked', (total_selected === _.size(this.views.notification) && total_selected > 0));
    },

    updateCounter: function() {
        this.$el.find('.empty-result').toggle(this.count === 0);

        this.$el.find('.notification-count').text(Numeral(Cache.inbox_notification.length).format('0,0') + ' of ' + Numeral(this.count).format('0,0') + ' notification' + (this.count === 1 ? '' : 's'));
        this.$el.find('.region-notification-body').attr('data-count', this.count + ' notification' + (this.count === 1 ? '' : 's'));
    },

    render: function() {
        UI.setPageTitle('Inbox');

        var content =
        '<div class="fullscroll-action-bar">' +
            '<div>' +
                '<div class="region-search">' +
                    '<div class="search">' +
                        '<form class="quick-search">' +
                            '<input type="text" placeholder="Search inbox" maxlength="100">' +
                            '<button type="button" class="quick-search-clear"><i class="fas fa-times-circle info"></i></button>' +
                        '</form>' +
                    '</div>' +
                    '<div>' +
                    '</div>' +
                '</div>' +
                '<div class="region-group-action">' +
                    '<div class="item-counter">' +
                        '<span></span>' +
                        '<a href="#" class="clear-selection tooltip" data-title="Clear"><i class="fas fa-times-circle info"></i></a>' +
                    '</div>' +
                    '<div class="group-buttons">' +
                        '<button type="button" class="bulk-read tertiary small min">Mark as read</button>' +
                        '<button type="button" class="bulk-unread tertiary small min">Mark as unread</button>' +
                        '<button type="button" class="bulk-delete secondary small min">Delete</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '<div class="region-global-inbox">' +
            '<div class="region-notification-filter">' +
                '<div class="flex-c">' +
                    '<input type="checkbox" id="notification_select_all"><label for="notification_select_all" class="notification-count"></label>' +
                    '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                        '<button type="button" class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                        '<div>' +
                            '<ul class="dropdown">' +
                                '<li class="delete-all">Delete all notifications</li>' +
                                '<li class="delete-all-read">Delete all read notifications</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div>' +
                    '<button type="button" class="filter-project text-info square small round tooltip" data-title="Notification Settings"><i class="fa-solid fa-bars-filter"></i></button>' +
                    '<div class="button-dropdown">' +
                        '<button type="button" class="text-info square small round tooltip" data-title="Display Options"><i class="fa-regular fa-sliders"></i></button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select dropdown-filters">' +
                                '<li class="filter-show-read' + (this.filters.show_read ? ' selected' : '') + '">Show read</li>' +
                                '<li class="filter-show-snoozed' + (this.filters.show_snoozed ? ' selected' : '') + '">Show snoozed</li>' +
                                '<li class="separator"></li>' +
                                '<li class="dropdown-title">Order</li>' +
                                '<li class="sort-order' + (this.filters.sort_order === 'DESC' ? ' selected' : '') + '" data-val="DESC">Newest first</li>' +
                                '<li class="sort-order' + (this.filters.sort_order === 'ASC'  ? ' selected' : '') + '" data-val="ASC">Oldest first</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="region-notification-list">' +
                '<div class="loading-result">' +
                    '<div class="loader-placeholder-small"></div>' +
                    '<div class="loader-placeholder-small"></div>' +
                    '<div class="loader-placeholder-small"></div>' +
                '</div>' +
                '<div class="empty-result">' +
                    '<h4 class="font-weight-semibold">Inbox Zero!</h4>' +
                    '<div>You cleared all of your notifications 🎉</div>' +
                '</div>' +
                '<div class="scroll-list"></div>' +
            '</div>' +
            '<div class="region-notification-body"></div>' +
        '</div>';

        this.$el.html(content);

        if (!Cache.account.hasFeature('inbox')) {
            Router.navigate('/project/', {trigger: true});
        }

        return this;
    }
});
